// extracted by mini-css-extract-plugin
export var layout = "Artists-module--layout--d4b07";
export var top = "Artists-module--top--beacc";
export var controlsWrapper = "Artists-module--controlsWrapper--b7162";
export var slider = "Artists-module--slider--57686";